import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { IncidentDetailPatientForSendai } from 'sections/sendai/features/useIncidentDetailForSendai';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { convertToPresenceAbsence } from 'core/components/common/converters';
import { FC } from 'react';

type Props = {
  relatedPersons: IncidentDetailPatientForSendai['baseInfo']['relatedPersons'];
  baseInfo: IncidentDetailPatientForSendai['baseInfo'];
};

export const RelatedPersonContactView: FC<Props> = ({
  relatedPersons,
  baseInfo,
}) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="関係者連絡" />
        {/* 家族等への連絡 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="家族等への連絡"
            content={baseInfo.familyContact ?? ''}
          />
          <InfoDisplay
            title="連絡先等"
            content={baseInfo.contactFamily ?? ''}
          />
        </div>
        {/* 傷病者所持品 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="傷病者所持品"
            content={baseInfo.custodyItems ?? ''}
          />
        </div>
        {/* 引継者 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="引継者" content={baseInfo.contactPerson ?? ''} />
        </div>
        {/* 警察接触 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="警察接触"
            content={convertToPresenceAbsence(baseInfo.policeContact)}
          />
          <InfoDisplay
            title="所属等"
            content={baseInfo.policeContactComment ?? ''}
          />
        </div>
        {/* 救急車同乗者実習 */}
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="救急車同乗者実習"
            content={baseInfo.ambulanceWithTraining ?? ''}
          />
          <InfoDisplay
            title="救急車同乗者実習(その他)"
            content={baseInfo.ambulanceWithTrainingComment ?? ''}
          />
        </div>
      </div>
    </BorderedContainer>
  );
};
